import { render, staticRenderFns } from "./personalAttempt.vue?vue&type=template&id=557f3818&scoped=true&"
import script from "./personalAttempt.vue?vue&type=script&lang=ts&"
export * from "./personalAttempt.vue?vue&type=script&lang=ts&"
import style0 from "./personalAttempt.vue?vue&type=style&index=0&id=557f3818&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557f3818",
  null
  
)

export default component.exports